export const FETCH_CHEMISTORDERDETAILS_INIT_ACTION =
  'FETCH_CHEMISTORDERDETAILS_INIT_ACTION';
export const FETCH_CHEMISTORDERDETAILS_SUCCESS_ACTION =
  FETCH_CHEMISTORDERDETAILS_INIT_ACTION + '_SUCCESS';
export const FETCH_CHEMISTORDERDETAILS_FAIL_ACTION =
  FETCH_CHEMISTORDERDETAILS_INIT_ACTION + '_ERROR';

export const FETCH_CHEMISTORDERVIEW_INIT_ACTION =
  'FETCH_CHEMISTORDERVIEW_INIT_ACTION';
export const FETCH_CHEMISTORDERVIEW_SUCCESS_ACTION =
  FETCH_CHEMISTORDERVIEW_INIT_ACTION + '_SUCCESS';
export const FETCH_CHEMISTORDERVIEW_FAIL_ACTION =
  FETCH_CHEMISTORDERVIEW_INIT_ACTION + '_ERROR';

export const EDIT_ITEMDETAILS_INIT_ACTION = 'EDIT_ITEMDETAILS_INIT_ACTION';
export const EDIT_ITEMDETAILS_SUCCESS_ACTION =
  EDIT_ITEMDETAILS_INIT_ACTION + '_SUCCESS';
export const EDIT_ITEMDETAILS_FAIL_ACTION =
  EDIT_ITEMDETAILS_INIT_ACTION + '_ERROR';

export const FETCH_ORDERINACTIVE_INIT_ACTION =
  'FETCH_ORDERINACTIVE_INIT_ACTION';
export const FETCH_ORDERINACTIVE_SUCCESS_ACTION =
  FETCH_ORDERINACTIVE_INIT_ACTION + '_SUCCESS';
export const FETCH_ORDERINACTIVE_FAIL_ACTION =
  FETCH_ORDERINACTIVE_INIT_ACTION + '_ERROR';

export const FETCH_CHEMISTINPROGRESSORDER_INIT_ACTION =
  'FETCH_CHEMISTINPROGRESSORDER_INIT_ACTION';
export const FETCH_CHEMISTINPROGRESSORDER_SUCCESS_ACTION =
  FETCH_CHEMISTINPROGRESSORDER_INIT_ACTION + '_SUCCESS';
export const FETCH_CHEMISTINPROGRESSORDER_FAIL_ACTION =
  FETCH_CHEMISTINPROGRESSORDER_INIT_ACTION + '_ERROR';

export const FETCH_CHEMISTCOMPLETEDORDER_INIT_ACTION =
  'FETCH_CHEMISTCOMPLETEDORDER_INIT_ACTION';
export const FETCH_CHEMISTCOMPLETEDORDER_SUCCESS_ACTION =
  FETCH_CHEMISTCOMPLETEDORDER_INIT_ACTION + '_SUCCESS';
export const FETCH_CHEMISTCOMPLETEDORDER_FAIL_ACTION =
  FETCH_CHEMISTCOMPLETEDORDER_INIT_ACTION + '_ERROR';

export const FETCH_CHEMISTCANCELLEDORDER_INIT_ACTION =
  'FETCH_CHEMISTCANCELLEDORDER_INIT_ACTION';
export const FETCH_CHEMISTCANCELLEDORDER_SUCCESS_ACTION =
  FETCH_CHEMISTCANCELLEDORDER_INIT_ACTION + '_SUCCESS';
export const FETCH_CHEMISTCANCELLEDORDER_FAIL_ACTION =
  FETCH_CHEMISTCANCELLEDORDER_INIT_ACTION + '_ERROR';

export const FETCH_DELIVERYSTATUS_INIT_ACTION =
  'FETCH_DELIVERYSTATUS_INIT_ACTION';
export const FETCH_DELIVERYSTATUS_SUCCESS_ACTION =
  FETCH_DELIVERYSTATUS_INIT_ACTION + '_SUCCESS';
export const FETCH_DELIVERYSTATUS_FAIL_ACTION =
  FETCH_DELIVERYSTATUS_INIT_ACTION + '_ERROR';

export const GET_COMPLETEITEMSURGENT_INIT_ACTION =
  'GET_COMPLETEITEMSURGENT_INIT_ACTION';
export const GET_COMPLETEITEMSURGENT_SUCCESS_ACTION =
  GET_COMPLETEITEMSURGENT_INIT_ACTION + '_SUCCESS';
export const GET_COMPLETEITEMSURGENT_FAIL_ACTION =
  GET_COMPLETEITEMSURGENT_INIT_ACTION + '_FAIL';

export const CREATE_INVOICEURGENT_INIT_ACTION =
  'CREATE_INVOICEURGENT_INIT_ACTION';
export const CREATE_INVOICEURGENT_SUCCESS_ACTION =
  CREATE_INVOICEURGENT_INIT_ACTION + '_SUCCESS';
export const CREATE_INVOICEURGENT_FAIL_ACTION =
  CREATE_INVOICEURGENT_INIT_ACTION + '_FAIL';

export const FETCH_ORDERSHIPPED_INIT_ACTION = 'FETCH_ORDERSHIPPED_INIT_ACTION';
export const FETCH_ORDERSHIPPED_SUCCESS_ACTION =
  FETCH_ORDERSHIPPED_INIT_ACTION + '_SUCCESS';
export const FETCH_ORDERSHIPPED_FAIL_ACTION =
  FETCH_ORDERSHIPPED_INIT_ACTION + '_ERROR';

export const FETCH_URGENTORDERDELIVERED_INIT_ACTION =
  'FETCH_URGENTORDERDELIVERED_INIT_ACTION';
export const FETCH_URGENTORDERDELIVERED_SUCCESS_ACTION =
  FETCH_URGENTORDERDELIVERED_INIT_ACTION + '_SUCCESS';
export const FETCH_URGENTORDERDELIVERED_FAIL_ACTION =
  FETCH_URGENTORDERDELIVERED_INIT_ACTION + '_ERROR';

export const CHANGE_PAYMENTSTATUS_INIT_ACTION =
  'CHANGE_PAYMENTSTATUS_INIT_ACTION';
export const CHANGE_PAYMENTSTATUS_SUCCESS_ACTION =
  CHANGE_PAYMENTSTATUS_INIT_ACTION + '_SUCCESS';
export const CHANGE_PAYMENTSTATUS_ERROR_ACTION =
  CHANGE_PAYMENTSTATUS_INIT_ACTION + '_ERROR';

export const ORDERPDF_REPORT_INIT_ACTION = 'ORDERPDF_REPORT_INIT_ACTION';
export const ORDERPDF_REPORT_SUCCESS_ACTION =
  ORDERPDF_REPORT_INIT_ACTION + '_SUCCESS';
export const ORDERPDF_REPORT_FAIL_ACTION =
  ORDERPDF_REPORT_INIT_ACTION + '_ERROR';

export const SEARCH_CHEMISTORDERVIEW_INIT_ACTION =
  'SEARCH_CHEMISTORDERVIEW_INIT_ACTION';
export const SEARCH_CHEMISTORDERVIEW_SUCCESS_ACTION =
  SEARCH_CHEMISTORDERVIEW_INIT_ACTION + '_SUCCESS';
export const SEARCH_CHEMISTORDERVIEW_FAIL_ACTION =
  SEARCH_CHEMISTORDERVIEW_INIT_ACTION + '_ERROR';

export const RETURN_PURCHASE_ORDER_ACTION = "RETURN_PURCHASE_ORDER_ACTION";
export const RETURN_PURCHASE_ORDER_SUCCESS_ACTION =
  "RETURN_PURCHASE_ORDER_SUCCESS_ACTION";
export const RETURN_PURCHASE_ORDER_FAIL_ACTION =
  "RETURN_PURCHASE_ORDER_FAIL_ACTION";

export function fetchChemistOrders(value) {
  return {
    type: FETCH_CHEMISTORDERDETAILS_INIT_ACTION,
    value: value,
  };
}
export function pageSelected(value) {
  return {
    type: FETCH_CHEMISTORDERDETAILS_INIT_ACTION,
    value: value,
  };
}
export function ChemistOrdersview(value) {
  return {
    type: FETCH_CHEMISTORDERVIEW_INIT_ACTION,
    value: value,
  };
}
export function EditItemDetails(value) {
  // console.log("EditItemDetails************+++accepted", value);
  return {
    type: EDIT_ITEMDETAILS_INIT_ACTION,
    value: value,
  };
}
export function ordersInActive(value) {
  return {
    type: FETCH_ORDERINACTIVE_INIT_ACTION,
    value: value,
  };
}
// export function OrdersViewpageSelected(value) {
//   return {
//     type: FETCH_CHEMISTORDERVIEW_INIT_ACTION,
//     value: value
//   };
// }

export function fetchChemistInprogressOrders(value) {
  return {
    type: FETCH_CHEMISTINPROGRESSORDER_INIT_ACTION,
    value: value,
  };
}

export function InprogressOrderspageSelected(value) {
  return {
    type: FETCH_CHEMISTINPROGRESSORDER_INIT_ACTION,
    value: value,
  };
}

export function fetchChemistCompletedOrders(value) {
  return {
    type: FETCH_CHEMISTCOMPLETEDORDER_INIT_ACTION,
    value: value,
  };
}
export function fetchChemistCancelledOrders(value) {
  return {
    type: FETCH_CHEMISTCANCELLEDORDER_INIT_ACTION,
    value: value,
  };
}
export function progresspageSelected(value) {
  return {
    type: FETCH_CHEMISTINPROGRESSORDER_INIT_ACTION,
    value: value,
  };
}
export function deliveredpageSelected(value) {
  return {
    type: FETCH_CHEMISTCOMPLETEDORDER_INIT_ACTION,
    value: value,
  };
}
export function cancelledpageSelected(value) {
  return {
    type: FETCH_CHEMISTCANCELLEDORDER_INIT_ACTION,
    value: value,
  };
}
export function fetchDeliveryStatus() {
  return {
    type: FETCH_DELIVERYSTATUS_INIT_ACTION,
  };
}

export function Totalitemretrieval(value) {
  return {
    type: GET_COMPLETEITEMSURGENT_INIT_ACTION,
    value: value,
  };
}

export function manualInvoice(value) {
  return {
    type: CREATE_INVOICEURGENT_INIT_ACTION,
    value: value,
  };
}
export function ordersShippedActive(value) {
  // console.log("ordersShippedActive====================");
  return {
    type: FETCH_ORDERSHIPPED_INIT_ACTION,
    value: value,
  };
}
export function UrgentordersDelivered(value) {
  return {
    type: FETCH_URGENTORDERDELIVERED_INIT_ACTION,
    value: value,
  };
}
export function OrdersViewpageSelected(value) {
  // console.log("OrdersViewpageSelected====================");
  return {
    type: FETCH_CHEMISTORDERVIEW_INIT_ACTION,
    value: value,
  };
}

export function changePaymentstatus(value) {
  return {
    type: CHANGE_PAYMENTSTATUS_INIT_ACTION,
    value: value,
  };
}

export function pdfOrderFullData(value) {
  return {
    type: ORDERPDF_REPORT_INIT_ACTION,
    value: value,
  };
}

export function fetchChemistitems(value) {
  console.log('#########22222222222222222', value);
  return {
    type: SEARCH_CHEMISTORDERVIEW_INIT_ACTION,
    value: value,
  };
}

export function createReturnOrder(value) {
  return {
    type: RETURN_PURCHASE_ORDER_ACTION,
    value: value,
  };
}

